module.exports = __webpack_public_path__ + "img/fits-into-all.d5b389e2.svg";